import { useFunction, useGetWidget } from '@libs/core';
import { TCommonData, TextInputEnum, TMainWidgetProps, TWidget } from '@libs/types';
import React from 'react';
import type { WidgetEnum } from './types/enums';
import { getWidgetById } from './fabric/widgets';

const Widget: React.FC<TMainWidgetProps> = ({ uid, widget, Package }) => {
    const { widget: finalWidget } = useGetWidget(uid ?? '', widget);

    useFunction(finalWidget ?? (widget as TWidget<TCommonData>));

    const getWidget = () => {
        const widgetById = getWidgetById(finalWidget?.id as WidgetEnum & TextInputEnum, finalWidget as TWidget<TCommonData>, Package);
        if (widgetById) {
            return widgetById;
        } else {
            return getWidgetById(finalWidget?.alternativeId as WidgetEnum & TextInputEnum, finalWidget as TWidget<TCommonData>, Package);
        }
    };

    return getWidget();
};
export default Widget;
